import { useSiteContent } from '@/context/SiteContent';

const LINE_STYLES = {
  ink: 'text-yunti-ink',
  green: 'text-yunti-green',
  purple: 'text-yunti-purple',
  soft: 'text-yunti-ink/60 font-sans text-xl md:text-2xl font-normal lowercase tracking-normal italic pt-2',
};

export function BrandIntro() {
  const { statement } = useSiteContent();
  return (
    <section
      id="brand"
      className="section-pad px-6 lg:px-12 bg-yunti-ground text-yunti-ink border-b border-yunti-ink/10"
      data-testid="brand-section"
    >
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-5 flex justify-center">
          <div className="drift-slow relative w-64 h-64 md:w-80 md:h-80 border border-yunti-ink/20 flex items-center justify-center p-6 bg-white shadow-sm">
            <div className="absolute inset-4 border border-dashed border-yunti-purple/30" aria-hidden="true" />
            <div className="text-center space-y-3 relative z-10">
              {statement.diagram_top && (
                <div className="text-xs font-mono text-yunti-green uppercase tracking-widest font-semibold">
                  {statement.diagram_top}
                </div>
              )}
              {statement.diagram_middle && (
                <div className="text-3xl font-display uppercase tracking-tight text-yunti-ink">{statement.diagram_middle}</div>
              )}
              {statement.diagram_bottom && (
                <div className="text-xs font-mono text-yunti-ink/50 tracking-wider">{statement.diagram_bottom}</div>
              )}
            </div>
            <span className="absolute top-2 left-2 text-[10px] font-mono text-yunti-ink/40">01 / REFLECT</span>
            <span className="absolute bottom-2 right-2 text-[10px] font-mono text-yunti-purple">02 / YOU</span>
          </div>
        </div>

        <div className="md:col-span-7 space-y-6">
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-yunti-purple font-semibold">{statement.eyebrow}</p>
          <div className="space-y-4 text-2xl md:text-3xl lg:text-4xl font-display uppercase tracking-tight leading-snug">
            {statement.lines.map((line, i) => (
              <p key={i} className={LINE_STYLES[line.style] || LINE_STYLES.ink}>
                {line.text}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
